import Image1 from "../../Assets/RoboCamp/Image1.JPG";
import Image2 from "../../Assets/RoboCamp/Image2.JPG";
import Image3 from "../../Assets/RoboCamp/Image3.JPG";
import Image4 from "../../Assets/RoboCamp/Image4.JPG";
import Image5 from "../../Assets/RoboCamp/Image5.JPG";
import Image6 from "../../Assets/RoboCamp/Image6.JPG";

export const SliderData = [
    {
        image: Image1
    },
    {
        image: Image2
    },
    {
        image: Image3
    },
    {
        image:Image4
    },
    {
        image: Image5
    },
    {
        image: Image6
    },
]
